export function hasValidCanonicalId(canonicalIdClaim) {
    if (!canonicalIdClaim || typeof canonicalIdClaim !== 'string')
        return false;
    return (canonicalIdClaim.toLowerCase().endsWith('@vista.com') ||
        canonicalIdClaim.toLowerCase().endsWith('@vistaprint.com') ||
        canonicalIdClaim.toLowerCase().endsWith('@affinityx.com'));
}
//# sourceMappingURL=utils.js.map